const state = {
  status: false
}

export default state
